
export interface Category {
  id: string;
  name: string;
}

export interface ProductImage {
  id: string;
  url: string;
  type: 'original' | 'generated' | 'edited' | 'video';
  style?: string; // For generated images
  createdAt: number;
}

export interface Product {
  id: string;
  name: string;
  description: string;
  categoryIds: string[];
  tags: string[];
  images: ProductImage[];
  createdAt: number;
  updatedAt: number;
}

export enum AestheticStyle {
  STUDIO_MINIMAL = 'Studio Minimal',
  DARK_LUXURY = 'Dark Luxury',
  GOLDEN_HOUR = 'Golden Hour',
  ETHEREAL_DREAM = 'Ethereal Dream',
  ARCHITECTURAL = 'Architectural',
  ORGANIC_NATURE = 'Organic Nature',
  UGC_SOCIAL = 'UGC Social',
  LIFE_SHOWCASE = 'Life Showcase',
  ON_MODEL = 'On Model',
}

export enum VeoModel {
  FAST = 'veo-3.1-fast-generate-preview',
  QUALITY = 'veo-3.1-generate-preview'
}

export enum ImageModel {
  NANO_BANANA = 'gemini-2.5-flash-image',
  NANO_BANANA_PRO = 'gemini-3-pro-image-preview'
}

export type CameraAngle = 'front' | 'isometric' | 'top-down' | 'low-angle' | 'macro' | 'side';

export interface StudioSettings {
  lighting: {
    intensity: 'soft' | 'medium' | 'hard' | 'dramatic';
    temperature: 'warm' | 'cool' | 'neutral';
  };
  background: {
    texture: string;
    color: string;
  };
  camera: {
    angle: CameraAngle;
    depthOfField: 'shallow' | 'medium' | 'deep';
  };
  props: string;
}

export enum ImageSize {
  SIZE_1K = '1K',
  SIZE_2K = '2K',
  SIZE_4K = '4K',
}

export interface GenerationConfig {
  prompt: string;
  imageBase64?: string;
  style?: AestheticStyle;
  size?: ImageSize;
  isPro?: boolean;
}

export interface CinematicPlan {
  title: string;
  description: string; // The video prompt
  editInstruction: string; // The instruction to create the end frame
  icon: 'zoom' | 'pan' | 'orbit' | 'focus';
}
